var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pta-admin" }, [
    _c("div", { staticClass: "page-titles border-bottom" }, [
      _c("h3", [
        _vm._v("Deals Section - Immediate Interface\n      "),
        _vm.clients
          ? _c("span", { staticClass: "card-subtitle" }, [
              _vm._v(
                _vm._s(
                  _vm.trans("general.total_result_found", {
                    count: _vm.clients.total,
                  })
                )
              ),
            ])
          : _c("span", { staticClass: "card-subtitle" }, [
              _vm._v(_vm._s(_vm.trans("general.no_result_found"))),
            ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container-fluid p-20",
        staticStyle: { "font-size": "0.75em" },
      },
      [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("transition", { attrs: { name: "fade" } }, [
                _vm.showFilterPanel
                  ? _c("div", { staticClass: "card border-bottom" }, [
                      _c("div", { staticClass: "card-body p-4" }, [
                        _c("h4", { staticClass: "card-title" }, [
                          _vm._v(_vm._s(_vm.trans("general.filter"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-6 col-sm-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "name" } }, [
                                _vm._v(_vm._s(_vm.trans("investor.name"))),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.filterClientForm.name,
                                    expression: "filterClientForm.name",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { id: "name", name: "name" },
                                domProps: { value: _vm.filterClientForm.name },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.filterClientForm,
                                      "name",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 col-sm-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "email" } }, [
                                _vm._v(
                                  _vm._s(_vm.trans("investor.contact_person"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.filterClientForm.contact_person,
                                    expression:
                                      "filterClientForm.contact_person",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  id: "contact_person",
                                  name: "contact_person",
                                },
                                domProps: {
                                  value: _vm.filterClientForm.contact_person,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.filterClientForm,
                                      "contact_person",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.showFilterPanel
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-danger btn-sm pull-right",
                                on: {
                                  click: function ($event) {
                                    _vm.showFilterPanel = !_vm.showFilterPanel
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.trans("general.cancel")))]
                            )
                          : _vm._e(),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.hasPermission("create-user")
                ? _c("transition", { attrs: { name: "fade" } }, [
                    _vm.showCreatePanel
                      ? _c("div", { staticClass: "card border-bottom" }, [
                          _c("div", { staticClass: "card-body p-4" }, [
                            _c(
                              "form",
                              {
                                attrs: { autocomplete: "off" },
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    return _vm.submit.apply(null, arguments)
                                  },
                                  keydown: function ($event) {
                                    return _vm.investorForm.errors.clear(
                                      $event.target.name
                                    )
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-12 col-sm-12" },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-12 col-sm-3" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c(
                                                  "label",
                                                  { attrs: { for: "" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.trans(
                                                          "investor.name"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.investorForm.name,
                                                      expression:
                                                        "investorForm.name",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "text",
                                                    value: "",
                                                    name: "name",
                                                    placeholder:
                                                      _vm.trans(
                                                        "investor.name"
                                                      ),
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.investorForm.name,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.investorForm,
                                                        "name",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("show-error", {
                                                  attrs: {
                                                    "form-name":
                                                      _vm.investorForm,
                                                    "prop-name": "name",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-12 col-sm-3" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c(
                                                  "label",
                                                  { attrs: { for: "" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.trans(
                                                          "investor.contact_person"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.investorForm
                                                          .contact_person,
                                                      expression:
                                                        "investorForm.contact_person",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "text",
                                                    value: "",
                                                    name: "contact_person",
                                                    placeholder: _vm.trans(
                                                      "investor.contact_person"
                                                    ),
                                                    autocomplete: "off",
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.investorForm
                                                        .contact_person,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.investorForm,
                                                        "contact_person",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("show-error", {
                                                  attrs: {
                                                    "form-name":
                                                      _vm.investorForm,
                                                    "prop-name":
                                                      "contact_person",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-info waves-effect waves-light pull-right",
                                    attrs: { type: "submit" },
                                  },
                                  [_vm._v(_vm._s(_vm.trans("general.add")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-danger waves-effect waves-light pull-right m-r-10",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        _vm.showCreatePanel =
                                          !_vm.showCreatePanel
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.trans("general.cancel")))]
                                ),
                              ]
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.clients.total
                ? _c("div", { staticClass: "card" }, [
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _vm.hasPermission("list-user") && _vm.clients.total
                          ? _c("div", { staticClass: "table-responsive" }, [
                              _c(
                                "table",
                                { staticClass: "table table-hover" },
                                [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v("ID"),
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v("Name of the client"),
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v("Active Email Campaigns"),
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v("Number of LP's active"),
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v(
                                          "Status (Intros Outstanding) % and No."
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "th",
                                        {
                                          staticClass: "table-option",
                                          attrs: { scope: "col" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.trans("general.action"))
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(_vm.clients.data, function (client) {
                                      return _c("tr", [
                                        _c("td", {
                                          domProps: {
                                            textContent: _vm._s(client.id),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("td", {
                                          domProps: {
                                            textContent: _vm._s(
                                              client.profile.company
                                            ),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("td", [_vm._v("0")]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(client.user_investors.length)
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [_vm._v("0 / 0")]),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "table-option" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "btn-group" },
                                              [
                                                _c(
                                                  "router-link",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "tooltip",
                                                        rawName: "v-tooltip",
                                                        value: "Show campains",
                                                        expression:
                                                          "'Show campains'",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "btn btn-info btn-sm",
                                                    attrs: {
                                                      to: `/account/deals/${client.id}`,
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fas fa-arrow-circle-right",
                                                    }),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ])
                                    }),
                                    0
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("pagination-record", {
                          attrs: {
                            "page-length": _vm.filterClientForm.page_length,
                            records: _vm.clients,
                          },
                          on: {
                            "update:pageLength": function ($event) {
                              return _vm.$set(
                                _vm.filterClientForm,
                                "page_length",
                                $event
                              )
                            },
                            "update:page-length": function ($event) {
                              return _vm.$set(
                                _vm.filterClientForm,
                                "page_length",
                                $event
                              )
                            },
                            updateRecords: _vm.getClients,
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }